import React, { useState, useEffect, useRef } from 'react';
import Styles from "../../styles.module.scss";
import FromHead from "../../../../components/headings/FromHead";
import FreeField from "../../../../components/field/freeField"; 
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import TagLabel from '../../../../components/TagLabel';
import Combodropdown from '../../../../components/autocomplete'
import { skills } from '../../../../utils/Skill';
import { jobRoles } from '../../../../utils/jobRoles';
import classnames from "classnames";
import { Icon } from '@iconify/react';
import RadioGroup from '../../../../components/radioGroup';
import { useForm } from 'react-hook-form';
import Button from '../../../../components/button';
import { Error } from "@progress/kendo-react-labels";
import * as Utils from '../../../../utils/EllowUtils'
import mixpanelData from '../../../../utils/mixpanel';
import { FormInput } from "../../../../wrappers/formInput";


  interface Props {

    OnSubmit: any
    defaultValues: {
      workExperience: number;
      jobRoles: { name: string; id: number; }[];
      techStack: { experience: string; expertise: number; skill: { skillId: number; skillName: string; }; stackId: number; }[];
      cloudProficiency: {id:number; name:string}[];
      otherSkills: { skillId: number, skillName: string }[];
      positionName: string;
    }
  }


  const Skills: React.FC<Props> = ({
    OnSubmit,
    defaultValues
  }) => {

  let email = localStorage.getItem('Email')
    
  const loginId = localStorage.getItem('loginId') || ''
  const [designation , setDesignation] = useState<any>()
  const [addedSkills, setAddedSkills] = useState<{ name: string, id: number, expertise: number, experience: string, other: boolean }[]>([])
  const [addedAdditionalSkills, setAddedAdditionalSkills] = useState<{ name: string, id: number | null, other: boolean }[]>([])
  const [skillOthers, setSkillOthers] = useState<boolean>(false)
  const [additionalSkillOthers, setAdditionalSkillOthers] = useState<boolean>(false)
  const [errors, setErros] = useState<{ workExp?: string, expertise?: string, experience?: string, engieering?: string, skills?: string,cloud?: string, englishProficiency?: string, designation?: string}>({ workExp: "", expertise: "", experience: "", engieering: "", skills: "", cloud:"", englishProficiency: "", designation: ""})
  const getAddedSkills = () => [...CONSTANTS.Skills, ...addedSkills.filter(item => item.other)]
  const getAddedAdditionalSkills = () => [...CONSTANTS.Skills, ...addedAdditionalSkills.filter(item => item.other)]
  const [cloudprof, setCloudprof] = useState<{name: string, id: number}[]>([])
  const getDefaultSkills = (item: { name: string, id: number }) => addedSkills ? !!addedSkills.filter(id => id.id === item.id).length : false
  const getDefaultAdditionalSkills = (item: { name: string, id: number | null }) => addedAdditionalSkills ? !! addedAdditionalSkills.filter(id => id.id === item.id).length : false
  const [engineeringOthers, setEngineeringOthers] = useState<boolean>(false)
  // const getDefaultCloudprof = (item: {name:string, id: number}) => cloudprof ? !! cloudprof.filter(id => id.id == item.id).length : false
  const [addedEngineering, setAddedEngineering] = useState<{ name: string, id: number, other: boolean }[]>([])
  const getDefaultJobRoles = (item: { name: string, id: number }) => addedEngineering ? !!addedEngineering.filter(id => id.id === item.id).length : false
  const getAddedEngineering = () => [...CONSTANTS.Engineering, ...addedEngineering.filter(item => item.other)]
  const [workExp, setWorkExp] = useState<any>({ years: "", months: "" })
  const inputRef = useRef<HTMLInputElement>(null)
  // const [additionalSkillsArray , setAddidtionalSkillsArray] = useState<any>()
  const [skillArray, setSkillArray] = useState<any>([])
    


  const engineeringChange = (e: any, engineering: { name: string, id: number }) => {
    
    delete errors.engieering
    setErros({ ...errors })
    let updatedEngineering: { name: string, id: number, other: boolean }
      = { ...engineering, other: e === 'addValue' }
    if (engineering !== null) {
      if ((e.value) || e === 'addValue') {
        addedEngineering.push(updatedEngineering)
        delete errors.engieering
        setErros({ ...errors })
        if (engineering.name === "Others") {
          setEngineeringOthers(true)
        }
      }
      else {
        const index = addedEngineering.findIndex(item => item.id === engineering.id);;
        if (index > -1) {
          addedEngineering.splice(index, 1);
        }
        if (engineering.name === "Others") {
          setEngineeringOthers(false)
        }

      }
      setAddedEngineering([...addedEngineering])
      setErros({ ...errors })
    }
    
  }
  const experienceChange = (e: any, fieldName: string) => {
    delete errors.workExp
    delete errors.experience
    workExp[fieldName] = e.target.value ? Math.abs(e.target.value) : ''
    setWorkExp({ ...workExp })
    setErros({ ...errors })
   
    
  }
  useEffect(() => {
   if(errors) {
      if (inputRef.current){   
      inputRef.current.scrollIntoView() 
      }
    }
  }, [errors])
  

  useEffect(() => {
    
    const cloudProficiency = defaultValues.cloudProficiency ? defaultValues.cloudProficiency.map(item => {
      return ({
        name: item.name, id: item.id,
      })
    }) : []
    setCloudprof(cloudProficiency)
     
    const jobRoles = defaultValues.jobRoles ? defaultValues.jobRoles.map(item => {
      return ({
        name: item.name, id: item.id,
        other: CONSTANTS.Engineering.filter(engineering => engineering.id === item.id).length === 0
      })
    }) : []
    setAddedEngineering(jobRoles)
    const techStack = defaultValues.techStack ? defaultValues.techStack.map(item => {
      return ({
        name: item.skill.skillName, id: item.skill.skillId, expertise: item.expertise, experience: item.experience,
        other: CONSTANTS.Skills.filter(skill => skill.id === item.skill.skillId).length === 0
      })
    }) : []
    let test = defaultValues.techStack ? defaultValues.techStack.map(item => {
      return (
        item.skill.skillId
      )
    }) : []
    setSkillArray(test)
    const otherSkill = defaultValues.otherSkills ? defaultValues.otherSkills.map(item => {
      return ({
        name: item.skillName, id: item.skillId,
        other: CONSTANTS.Skills.filter(skill => skill.id === item.skillId).length === 0
      })
    }) : []
    setAddedSkills(techStack)
    setAddedAdditionalSkills(otherSkill)
    setWorkExp(defaultValues.workExperience ? {
      years: Utils.workexperience(defaultValues.workExperience, 0), months: Utils.workexperience(defaultValues.workExperience, 1)
    } : { years: "", months: "" })
    setDesignation(defaultValues.positionName ? defaultValues.positionName : ' ' )  
  }, [defaultValues])

  const expertiseChange = (e: any, skill: any, fieldName: string, type: string) => {
    
    const index = addedSkills.indexOf(skill, 0);
    if (fieldName === "expertise") {
      addedSkills[index].expertise = e.value
    }
    else {
      if (type) {
        if (isNaN(parseInt(addedSkills[index].experience)))
          addedSkills[index].experience = "1"
        else {
          switch (type) {
            case "add":
              addedSkills[index].experience = (parseInt(addedSkills[index].experience) + 1).toString()
              break
            case "subtract":
              addedSkills[index].experience = (parseFloat(addedSkills[index].experience) - 1).toString()
              break
          }
        }

      }
      else
        addedSkills[index].experience = e.target.value
    }
    delete errors.expertise
    delete errors.experience
    setErros({ ...errors })
    setAddedSkills([...addedSkills])
  }
 
  const skillChange = (e: any, skill: { name: string, id: number }) => {
    delete errors.expertise
    setErros({ ...errors })
    let updatedSkill: { name: string, id: number, expertise: number, experience: "", other: boolean }
      = { ...skill, expertise: 0, experience: "", other: e === 'addValue' }
    let newSkill:number = skill.id
    if (skill !== null) {
      if (e.value || e === 'addValue') {
        skillArray.push(newSkill);
        addedSkills.push(updatedSkill);
        setErros({ ...errors })
        if (skill.name === "Others") {
          setSkillOthers(true)
        }
      }
      else {
        const index = addedSkills.findIndex(item => item.id === skill.id);
        if (index > -1) {
          addedSkills.splice(index, 1);
          skillArray.splice(index, 1);
        }
        if (skill.name === "Others") {
          setSkillOthers(false)
        }
      }
    }
    setAddedSkills([...addedSkills])
    }
    
    const additionalSkillChange = (e: any, skill: { name: string, id: number | null }) => {
      
     if (skillArray && !(skillArray.includes(skill.id))) {
      let updatedSkill: { name: string, id: number | null, expertise: number, experience: "", other: boolean }
        = { ...skill, expertise: 0, experience: "", other: e === 'addValue' }
    
      if (skill !== null) {
        if (e.value || e === 'addValue') {
          addedAdditionalSkills.push(updatedSkill)
          setErros({ ...errors })
          if (skill.name === "Others") {
            setAdditionalSkillOthers(true)
          }
        }
        else {
          const index = addedAdditionalSkills.findIndex(item => item.id === skill.id);
          if (index > -1) {
            addedAdditionalSkills.splice(index, 1);
          }
          if (skill.name === "Others") {
            setAdditionalSkillOthers(false)
          }
        }
      }
      setAddedAdditionalSkills([...addedAdditionalSkills])
    }
  }

//   const cloudprofChange = (e:any , cloud: { name: string, id: number } ) =>{
     
//     delete errors.cloud
//       setErros({ ...errors })

//     // let updatedCloud: { name: string, id: number}
//     // = {...cloud} 
    
    
//   if (cloud !== null) {
//     if ((e.value) || e === 'addValue') {
//       cloudprof.push(cloud)
//       delete errors.cloud

//       setErros({ ...errors })
//     }
//     else {
//       const index = cloudprof.findIndex(item => item.id === cloud.id);
//       if (index > -1) {
//         cloudprof.splice(index, 1);
//       }
//     }
//     setCloudprof([...cloudprof])
//     setErros({ ...errors })
//   }  
// }

const {
  // register,
  handleSubmit,
  // formState: { errors },
} = useForm();

const onSubmit = () => {
    
  let isErrored = false
  let techStack: any[] = []
  let jobRoles: any[] = []
  let otherSkills: any[] = []
  let rolesWithoutOthers = addedEngineering.filter((item) => item.name !== 'Others')

  if (!workExp.years && workExp.years !== 0) {
    errors.workExp = "Please add years of experience"
    isErrored = true
  }

  if ((!rolesWithoutOthers || rolesWithoutOthers.length === 0)) {
    errors.engieering = "Select atleast one role "
    isErrored = true
  } else if (rolesWithoutOthers.length > 3) {
    errors.engieering = "Maximum three roles are allowed"
    isErrored = true
  }

  const skillWithoutOthers = addedSkills.filter((item) => item.name !== 'Others')
  const additionalSkillWithoutOthers = addedAdditionalSkills.filter((item) => item.name !== 'Others')
  
  if((!designation || designation.length === 0)) {  
    errors.designation = "Please add your designation"
    isErrored = true
  }
   
  if ((!skillWithoutOthers || skillWithoutOthers.length === 0)) {
    errors.expertise = "Please add atleast one skill "
    isErrored = true
  }
  if (skillWithoutOthers.length > 3) {
    errors.expertise = "Maximum three skills are allowed"
    isErrored = true
  }

  jobRoles = rolesWithoutOthers.map((item, i) => {
    return ({
      "name": item.name,
      "id": item.id
    })
  })

  techStack = skillWithoutOthers.map((item, i) => {
    if (!item.experience) {
      errors.expertise = "Please add experience"
      isErrored = true
      // return
    }
    else if (!item.expertise) {
      errors.expertise = "Please add the expertise "
      isErrored = true
      // return
    }
    if (parseInt(item.experience) > parseInt(workExp.years)) {
      errors.expertise = "Skills experience should not exceed the overall experience"
      isErrored = true
      return
    }
    return ({
      "stackId": i,
      "skill": {
        "skillId": item.id,
        "skillName": item.name
      },
      "experience": item.experience,
      "expertise": item.expertise
    })
  })

  otherSkills =  additionalSkillWithoutOthers.map((item, i) => {
    return ({
        "skillId": item.id,
        "skillName": item.name
    })
  })

  if (isErrored) {
      if (inputRef.current){   
      inputRef.current.scrollIntoView() 
      }
    setErros({ ...errors })
    return
  }

  let data = {
      "workExperience": parseFloat(`${workExp.years}.${workExp.months}`),
      "jobRoles": jobRoles,
      "cloudProficiency" : cloudprof,
      "techStack": techStack,
      "otherSkills": otherSkills,
      "positionName": designation,
  }
   
   localStorage.setItem('jobroles',data.jobRoles[0].name)
   const skillsName = data && data.techStack && data.techStack.map((item, experience, expertise) => { return (item.skill.skillName) })
   const jobRolesNames: string[] = data && data.jobRoles && data.jobRoles.map((item: { id: number, name: string }) => { return (item.name) })
   const otherSkillsName = data && data.otherSkills.length > 0 && data.otherSkills.map((item: any) => { return (item.skillName)})
   if(data){
    mixpanelData('MWP-Skills Updated', {
      'distinct_id': email && email,
      'workExperience': data && data.workExperience,
      'JobRoles': jobRolesNames,
      'Skills': skillsName,
      'Email': email,
      'OtherSkills': otherSkillsName,
      
    })
    mixpanelData('New MWP - Skills updated', {
      'distinct_id': email && email,
      'Candidate loginid': loginId,
      'Work experience': data && data.workExperience,
      'Job role': jobRolesNames,
      'Core skills': skillsName,
      'Candidate email': email,
      "Designation": designation,
      'Additional skills': otherSkillsName, 
    })
  }
  OnSubmit(data) 
}

const designationChange = (e: any) => {
  delete errors.designation
  setDesignation(e.target.value) 
}

    return (
      <section>
        {/* <Headline4>Skills</Headline4> */}
        {errors.workExp  &&  <p id='workExp' ref={inputRef}></p>}
        <FromHead>
          How many years of professional experience do you have ?*
        </FromHead>
        <div   className="form-group mb-40">
          <p  className={Styles.experienceWrap}>
            I have
            <FreeField
              id="years"
              name='years'
              placeholder=""
              type="number"
              autoComplete='off'
              size="small"
              value={workExp.years}
              onChange={(e: any) => experienceChange(e, "years")}
            />
            years and
            <FreeField
              id="months"
              placeholder=""
              autoComplete='off'
              type="number"
              size="small"
              // min="0"
              value={workExp.months}
              onChange={(e: any) => experienceChange(e, "months")}
            />
            months of experience in software development
          </p>
        <Error>{errors?.workExp}</Error>
        </div>
        {errors.engieering && !errors.workExp && <p id='engineering' ref={inputRef}></p>}
        <FromHead>What engineering role identifies you better?*</FromHead>
        <div  className="form-group mb-40">
        {getAddedEngineering().map((item, key) => <TagLabel label={item.name}
          key={key}
          value={item.id}
          checked={getDefaultJobRoles(item)}
          handleChange={(e: any) => engineeringChange(e, item)} />)}
        {engineeringOthers && <div className={Styles.tagDropdown}>
          <Combodropdown
            placeholder="Please search your role"
            data={jobRoles}
            name='name'
            id='id'
            handleChange={(value: { name: string, id: number, other: boolean }) => engineeringChange('addValue', value)
            }
          />
        </div>}
        {errors?.engieering && <p > <Error>{errors?.engieering}</Error> </p> }
        </div>
        <FromHead>
        Add your designation
        </FromHead>
        <div className="half-form-wrap">
          <div className="form-group">
            <FormInput
              id="designation"
              type="text"
              name="designation"
              value={designation}
              onChange={(e: any) =>{designationChange(e)}}
            />
            <Error>{errors?.designation}</Error>
          </div>
        </div>
        <FromHead>Which are the skills you’re really good at?*</FromHead>
        <p>Please add (at least one or max of three of) your Core skills, years of experience and the competency of each skill</p>
        <div  className="form-group mb-40">
        {(errors?.experience || errors?.expertise) && !errors.workExp && !errors.engieering && <p id='exp and expet' ref={inputRef}></p>}
          {getAddedSkills().map((skill, key) => 
            <TagLabel label={skill.name}
              key={key}
              value={skill.id}
              checked={getDefaultSkills(skill)}
              handleChange={(e: any) => skillChange(e, skill)} 
            />
          )}
          {skillOthers && 
            <div className={Styles.tagDropdown}>
              <Combodropdown
                placeholder="Please search your skill"
                data={skills}
                name='name'
                id='id'
                handleChange={(value: { name: string, id: number }) => skillChange("addValue", value)}
              />
            </div>}
        </div>
        <FromHead>Additional skills</FromHead>
        <div  className="form-group mb-40">
          {getAddedAdditionalSkills().map((skill, key) => 
            <TagLabel 
              label={skill.name}
              key={key}
              value={skill.id}
              checked={getDefaultAdditionalSkills(skill)}
              handleChange={(e: any) => additionalSkillChange(e, skill)} 
            />
          )}
          {additionalSkillOthers && 
            <div className={Styles.tagDropdown}>
              <Combodropdown
                placeholder="Please search your skill"
                data={skills}
                name='name'
                id='id'
                handleChange={(value: { name: string, id: number }) => additionalSkillChange("addValue", value)}
              />
            </div>}
        </div>

        <FromHead>Add your experience and how competent you are with each of them?*</FromHead>
        <p>This is based on your skill selection from above section</p>
        <div className="form-group mb-40">
        {addedSkills.filter((item) => item.name !== 'Others').map((skill, key) => <div className={Styles.tachSkills} key={key}>
        <label className={Styles.techLabel}>{skill.name}</label>
        <div className={Styles.skillValue}>
          <button onClick={(e: any) => expertiseChange(e, skill, "experience", "subtract")} disabled={(!skill.experience || skill.experience === '0') ? true : false}>
            <Icon icon="akar-icons:circle-minus"
            /></button>
          <div  className={classnames('form-group', Styles.valueInput)}>
            <FreeField
              id="experience"
              placeholder="experience"
              size="small"
              type='number'
              // max={workExp.years}
              value={skill.experience ?  Math.abs(parseInt(skill.experience)) : ''}
              onChange={(e: any) => expertiseChange(e, skill, "experience", "")}
            />
          </div>
          <button onClick={(e: any) => expertiseChange(e, skill, "experience", "add")}
          ><Icon icon="akar-icons:circle-plus" /></button>
        </div>
        <div className={Styles.expertValueWrap}>
          <RadioGroup  data={CONSTANTS.Expertise}
            layout="horizontal"
            handleChange={(e: any) => expertiseChange(e, skill, "expertise", "")}
            checked={skill.expertise} />

        </div>
      </div>)}
      { (errors?.experience || errors?.expertise)  && <p>
      <Error>{errors?.experience}</Error>
      <Error>{errors?.expertise}</Error>
      </p> }
        </div>

        

        {/* <FromHead>Cloud Proficiency</FromHead>
        <div className="form-group">
        {CONSTANTS.cloudProficiency.map((cloud, key) =><TagLabel 
                label={cloud.name}
                key={key}
                value={cloud.id}
                checked={getDefaultCloudprof(cloud)}
                handleChange={(e: any) => cloudprofChange(e, cloud)} />)}
           <Error>{errors?.cloud}</Error>
        </div> */}
        <div className={Styles.alignRight}>
        <Button onClick={handleSubmit(onSubmit)} variant="primary">Save</Button>
        </div>
      </section>
    );
}
export default Skills